import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  center () {
    this.element.scrollLeft = (this.element.scrollWidth - this.element.offsetWidth) / 2
  }
}
